<template>
  <b-container fluid class="about">
    <b-row>
      <b-col style="padding: 0px;">
        <div class="text-center backgroundImg" v-bind:style="{background: 'url(' + getImage(bannerImg, 'banner') +')'}" >
          <div class="title-top text-uppercase">{{aboutTitleTop}}</div>
          <div class="title-middle text-uppercase primaryColor">{{aboutTitleMid}}</div>
          <center>
            <div class="title-bottom">
                {{aboutTitleBot}}
            </div>
          </center>
        </div>
      </b-col>
    </b-row>
    <!-- Why Us -->
    <b-row class="section1">
      <b-col lg="6" md="6" sm="12" xs="12" class="mb-5">
        <div class="text-uppercase text-center p-3 mt-5 mb-3 whyUs">
          <h2>{{aboutDynamicText1}}</h2>
        </div>
        <div class="mb-5">
          {{aboutDynamicText2}}
        </div>
        <div>
          <b-row class="text-left">
            <b-col lg="6" md="6" sm="12" xs="12" class="p-3">
              <div class="title text-uppercase primaryColor">{{aboutWhyUsTitle1}}</div>
              <div>
                {{aboutWhyUsDescription1}}
              </div>
            </b-col>
            <b-col lg="6" md="6" sm="12" xs="12" class="p-3">
              <div class="title text-uppercase primaryColor">{{aboutWhyUsTitle2}}</div>
              <div>
                {{aboutWhyUsDescription2}}
              </div>
            </b-col>
            <b-col lg="6" md="6" sm="12" xs="12" class="p-3">
              <div class="title text-uppercase primaryColor">{{aboutWhyUsTitle3}}</div>
              <div>
                {{aboutWhyUsDescription3}}
              </div>
            </b-col>
            <b-col lg="6" md="6" sm="12" xs="12" class="p-3">
              <div class="title text-uppercase primaryColor">{{aboutWhyUsTitle4}}</div>
              <div>
                {{aboutWhyUsDescription4}}
              </div>
            </b-col>
          </b-row>
        </div>
      </b-col>
      <b-col lg="6" md="6" class="d-none d-md-block">
        <img src="../assets/why-us.png" alt="Why Us">
      </b-col>
    </b-row>
    <!-- Clients -->
    <b-row class="section2 p-5">
      <b-col lg="12" md="12" sm="12" xs="12">
        <div>
          <h3>Klien Kami</h3>
        </div>
      </b-col>
    </b-row>
    <b-row class="section3 m-5">
      <b-col v-for="(client, index) in clients" :key="index" lg="4" md="4" sm="12" xs="12">
        <center>
          <img class="clientLogo" :src="getImage(client.attributes.image.data.attributes.url, 'url')">
        </center>
      </b-col>
    </b-row>
    <!-- Values -->
    <b-row class="section4 p-5 text-left">
      <b-col lg="12" md="12" sm="12" xs="12">
        <div id="promises">Visi & Misi Kami</div>
      </b-col>
      <b-col lg="6" md="6" sm="12" xs="12">
        <div id="promise" v-if="visionMissionTitle1 != '-'">
          <div class="value">{{visionMissionTitle1}}</div>
          <div>
            {{visionMissionDescription1}}
          </div>
        </div>
        <div id="promise" v-if="visionMissionTitle3 != '-'">
          <div class="value">{{visionMissionTitle3}}</div>
          <div>
            {{visionMissionDescription3}}
          </div>
        </div>
        <div id="promise" v-if="visionMissionTitle5 != '-'">
          <div class="value">{{visionMissionTitle5}}</div>
          <div>
            {{visionMissionDescription5}}
          </div>
        </div>
        <div id="promise" v-if="visionMissionTitle7 != '-'">
          <div class="value">{{visionMissionTitle7}}</div>
          <div>
            {{visionMissionDescription7}}
          </div>
        </div>
      </b-col>
      <b-col lg="6" md="6" sm="12" xs="12">
        <div id="promise" v-if="visionMissionTitle2 != '-'">
          <div class="value">{{visionMissionTitle2}}</div>
          <div>
            {{visionMissionDescription2}}
          </div>
        </div>
        <div id="promise" v-if="visionMissionTitle4 != '-'">
          <div class="value">{{visionMissionTitle4}}</div>
          <div>
            {{visionMissionDescription4}}
          </div>
        </div>
        <div id="promise" v-if="visionMissionTitle6 != '-'">
          <div class="value">{{visionMissionTitle6}}</div>
          <div>
            {{visionMissionDescription6}}
          </div>
        </div>
        <div id="promise" v-if="visionMissionTitle8 != '-'">
          <div class="value">{{visionMissionTitle8}}</div>
          <div>
            {{visionMissionDescription8}}
          </div>
        </div>
      </b-col>
    </b-row>
</b-container>
</template>

<script>
import util from '@/util'
import {mapGetters} from 'vuex'

export default {
  name: 'About',
  data () {
    return {
      bannerImg: 'dsk-about-bg.jpg'
    }
  },
  methods: {
    getImage (imageName, section) {
      return util.getImage(imageName, section)
    },
    findAllClients () {
      this.isLoading = true
      this.$store.dispatch('findAllClients', {
        success: (res) => {
        },
        fail: () => {
          this.toast('Could not get clients. Try again later.', 'error', 'error_outline')
        }
      }).then(() => {
        this.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    findAllContents () {
      this.isLoading = true
      this.$store.dispatch('findAllContents', {
        success: (res) => {
        },
        fail: () => {
          this.toast('Could not get contents. Try again later.', 'error', 'error_outline')
        }
      }).then(() => {
        this.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    findContentById (id) {
      this.$data.isLoading = true
      this.$store.dispatch('findContentById', {
        data: {
          id: id
        },
        success: () => {
        },
        fail: () => {
          this.toast('Something went wrong. Try again later.', 'error', 'error_outline')
        }
      }).then(() => {
        this.$data.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    }
  },
  created () {
    /*
    this.findContentById('aboutTitleTop')
    this.findContentById('aboutTitleMid')
    this.findContentById('aboutTitleBot')
    this.findContentById('aboutDynamicText1')
    this.findContentById('aboutDynamicText2')
    this.findContentById('aboutWhyUsTitle1')
    this.findContentById('aboutWhyUsDescription1')
    this.findContentById('aboutWhyUsTitle2')
    this.findContentById('aboutWhyUsDescription2')
    this.findContentById('aboutWhyUsTitle3')
    this.findContentById('aboutWhyUsDescription3')
    this.findContentById('aboutWhyUsTitle4')
    this.findContentById('aboutWhyUsDescription4')
    this.findContentById('visionMissionTitle1')
    this.findContentById('visionMissionDescription1')
    this.findContentById('visionMissionTitle2')
    this.findContentById('visionMissionDescription2')
    this.findContentById('visionMissionTitle3')
    this.findContentById('visionMissionDescription3')
    this.findContentById('visionMissionTitle4')
    this.findContentById('visionMissionDescription4')
    this.findContentById('visionMissionTitle5')
    this.findContentById('visionMissionDescription5')
    this.findContentById('visionMissionTitle6')
    this.findContentById('visionMissionDescription6')
    this.findContentById('visionMissionTitle7')
    this.findContentById('visionMissionDescription7')
    this.findContentById('visionMissionTitle8')
    this.findContentById('visionMissionDescription8')
    */
    this.findAllContents()
    this.findAllClients()
  },
  computed: {
    ...mapGetters([
      'aboutTitleTop', 'aboutTitleMid', 'aboutTitleBot', 'aboutDynamicText1', 'aboutDynamicText2', 'aboutWhyUsTitle1', 'aboutWhyUsDescription1', 'aboutWhyUsTitle2', 'aboutWhyUsDescription2', 'aboutWhyUsTitle3', 'aboutWhyUsDescription3', 'aboutWhyUsTitle4', 'aboutWhyUsDescription4',
      'visionMissionTitle1', 'visionMissionDescription1', 'visionMissionTitle2', 'visionMissionDescription2', 'visionMissionTitle3', 'visionMissionDescription3', 'visionMissionTitle4', 'visionMissionDescription4', 'visionMissionTitle5', 'visionMissionDescription5', 'visionMissionTitle6', 'visionMissionDescription6', 'visionMissionTitle7', 'visionMissionDescription7', 'visionMissionTitle8', 'visionMissionDescription8',
      'clients'
    ])
  }
}
</script>

<style scoped>
.backgroundImg {
  background:
    linear-gradient(
      rgba(0, 0, 0, 0.45)
    ),
    url(../assets/dsk-about-bg.jpg) center top no-repeat;
  background-size: cover !important;
  min-height: 95vh;
  color: #fff;
}
.title-top {
  padding-top: 25vh;
  font-size: 1.2em;
}
.title-middle {
  padding-top: 50px;
  font-size: 2em;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bolder;
  letter-spacing: 5px;
}
.title-bottom {
  padding: 40px 10px 20px 10px;
  max-width: 950px;
  font-size: 1.2em;
}
.section1 {
  margin: 60px 0px 0px 0px;
  padding-bottom: 0px;
}
.whyUs {
  letter-spacing: 10px;
  font-family: Georgia, Times, 'Times New Roman', serif;
  font-weight: bolder;
}
.title {
  font-size: 1.5em;
  font-weight: bolder;
}
.section2 {
  background-color: #000;
  color: #fff;
}
.clientLogo {
  width: 100%;
  height: 100%;
}
.section4 {
  background-color: #F2F2F2;
}
#promises {
  font-family: Geneva, Verdana, sans-serif;
  font-weight: bolder;
  font-size: 2.5em;
  letter-spacing: -2px;
}
#promise {
  margin-top: 20px;
}
#promise .value {
  font-weight: bolder;
  font-size: 1.2em;
}
.section3 {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue